import RegistrationService from '@app/model/registration/service/RegistrationService';
import Process from '@app/model/process-request/Process';
import {
	useLatestProcessRequestExecutionStateMonitor
} from '@app/site/secured/rateshopper/rates/provider/useLatestProcessRequestExecutionStateMonitor';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import ProcessRequestExecutionState from '@app/model/process-request/ProcessRequestExecutionState';


const useExecuteRegistrationEnrichHotelsHook = () => {

	const monitor = useLatestProcessRequestExecutionStateMonitor();
	const [hasFailed, setHasFailed] = useState(false);

	const START_FUNCTION = useMutation({
			mutationFn: RegistrationService.runEnrichCompanyHotels,
			onSuccess: (state) => {
				monitor.setLatestActiveExecutionState(new ProcessRequestExecutionState(state));
			},
			onError: () => {
				setHasFailed(true);
			}
		})


	return {
		start: START_FUNCTION.mutateAsync,
		isFinished: monitor.latestActiveExecutionState?.process === Process.HOTEL_INFO && monitor.latestActiveExecutionState.isSuccessful,
		hasFailed: hasFailed || (monitor.latestActiveExecutionState?.process === Process.HOTEL_INFO && monitor.latestActiveExecutionState.hasFailed),
	};

};

export default useExecuteRegistrationEnrichHotelsHook;
